import { formatWeight } from "./formatWeight";

interface TooltipItem {
  axisValue?: string;
  data: unknown;
  marker: string;
  seriesName: string;
  value: number;
}

interface TooltipRow {
  level: "recipe" | "charge";
  recipeName: string;
  chargeNumber: number | null;
}

const rowTitle = (row: TooltipRow | undefined) =>
  row?.level === "charge"
    ? `${row.recipeName} · Ch. ${row.chargeNumber}`
    : (row?.recipeName ?? "");

export const formatCompositionTooltip = (
  params: TooltipItem | TooltipItem[],
  rowsById: ReadonlyMap<string, TooltipRow>,
) => {
  const items = (Array.isArray(params) ? params : [params]).filter(
    (item) => item.data !== null && item.data !== undefined,
  );
  if (items.length === 0) return "";
  return [
    `<b>${rowTitle(rowsById.get(String(items[0].axisValue)))}</b>`,
    ...items.map(
      (item) =>
        `${item.marker}${item.seriesName}<span style="float:right;margin-left:16px;font-weight:600">${formatWeight(item.value)} lb</span>`,
    ),
  ].join("<br/>");
};
